import actions from "./actions";


const setIncident = actions.setIncident;
const clearIncident = actions.clearIncident;
const setRelationships = actions.setRelationships;
const clearRelationships = actions.clearRelationships;
const setADSStatus = actions.setADSStatus;
const clearADSStatus = actions.clearADSStatus;
const setPerimeter = actions.setPerimeter;
const setPerimeterFields = actions.setPerimeterFields;
const setNewIncidentProtectingUnit = actions.setNewIncidentProtectingUnit;
const clearPerimeter = actions.clearPerimeter;
const clearPerimeterFields = actions.clearPerimeterFields;
const setPreIncidentExtent = actions.setPreIncidentExtent;

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  setIncident,
  clearIncident,
  setPerimeter,
  setPerimeterFields,
  setRelationships,
  clearRelationships,
  clearPerimeter,
  clearPerimeterFields,
  setNewIncidentProtectingUnit,
  setADSStatus,
  clearADSStatus,
  setPreIncidentExtent
};
